import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import ReactTooltip from 'react-tooltip';
import classes from './ContactCard.scss';
// import { connect } from 'react-redux';
import { simplAvatarUrl } from '../../api/simplApi';

// const mapActionCreators = {};
//
// const mapStateToProps = state => ({
//   simplAccount: state.login.simplAccount,
// });

export class ContactCard extends React.Component {
  render() {
    let tooltip = <div />;

    if (this.props.name.length === 0 && this.props.id.length === 0) {
      return null;
    }

    const avatar = simplAvatarUrl(
      this.props.type,
      this.props.id,
      32,
      32,
      'crop',
    );

    const avatarCard = simplAvatarUrl(
      this.props.type,
      this.props.id,
      340,
      240,
      'crop',
    );

    // console.log(this.props.name, avatar);

    if (this.props.displayType === 'card') {
      return (
        <Link
          to={`/${this.props.type}/${this.props.id}`}
          className={`col-xs-12 col-sm-6 no-underline col-paddingless ${this.props.className}`}
          data-tip={this.props.name}
        >
          <div className={classes.contactcard}>
            <div className="row row-marginless">
              <div
                className={`col-xs-4 ${classes.avatar}`}
                style={{ backgroundImage: `url('${avatarCard}')` }}
              />
              <div className={`col-xs-8 ${classes.textblock}`}>
                <h4>{this.props.name}</h4>
                <span className={classes.position}>{this.props.position}</span>
                <span>{this.props.mobile}</span>
                <span>{this.props.number}</span>
                <span>{this.props.email}</span>
              </div>
            </div>
          </div>
        </Link>
      );
    } else if (this.props.displayType === 'imageOnly') {
      tooltip = (
        <ReactTooltip
          className={classes.tooltip}
          place="left"
          type="dark"
          effect="solid"
          html
        />
      );
      return (
        <Link
          to={`/${this.props.type}/${this.props.id}`}
          className={`classes.inline ${this.props.className}`}
        >
          <img
            src={avatar}
            className={classes.inlineImg}
            alt=""
            data-tip={this.props.name}
          />
          {tooltip}
        </Link>
      );
    }
    return (
      <Link
        to={`/${this.props.type}/${this.props.id}`}
        className={`${classes.inline} ${this.props.className}`}
      >
        <img
          src={avatar}
          className={classes.inlineImg}
          alt=""
          data-tip={this.props.name}
        />
        {this.props.name}
        {tooltip}
      </Link>
    );
  }
}

ContactCard.propTypes = {
  name: PropTypes.string,
  number: PropTypes.string,
  mobile: PropTypes.string,
  email: PropTypes.string,
  position: PropTypes.string,
  avatar: PropTypes.string,
  avatarId: PropTypes.string,
  type: PropTypes.string,
  id: PropTypes.string,
  displayType: PropTypes.string,
  className: PropTypes.string,
  simplAccount: PropTypes.string,
};

ContactCard.defaultProps = {
  name: '',
  className: '',
  type: 'person',
  id: '',
  displayType: 'inline',
  avatarId: '',
  simplAccount: '',
};

// export default connect(mapStateToProps, mapActionCreators)(ContactCard);
export default ContactCard;



// WEBPACK FOOTER //
// ./src/components/ContactCard/ContactCard.js